import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, DatePicker, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import api from "../../services/api";
import moment from "moment";

const { Option } = Select;

const MatchFormModal = ({
  open,
  onClose,
  onSuccess,
  tournaments,
  defaultTournamentId,
  initialData = null,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [posterFile, setPosterFile] = useState(null);
  const [posterPreview, setPosterPreview] = useState(null);

  useEffect(() => {
    if (defaultTournamentId && !initialData) {
      form.setFieldsValue({ tournament_id: defaultTournamentId });
    }
  }, [defaultTournamentId, initialData, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        name: values.name,
        tournament_id: values.tournament_id,
        start_time: values.start_date.format("YYYY-MM-DD HH:mm:ss"),
        end_time: values.end_date
          ? values.end_date.format("YYYY-MM-DD HH:mm:ss")
          : null,
        match_type: values.level || "domestic",
        status: values.status || "upcoming",
        overs: values.overs || 20,
      };

      const res = await api.post("/matches", payload);
      const matchId = res.data.data.match_id;

      if (values.youtube_link) {
        await api.put(`/matches/${matchId}/youtube-link`, {
          youtube_link: values.youtube_link,
        });
      }

      if (posterFile) {
        const fd = new FormData();
        fd.append("poster", posterFile);
        await api.post(`/matches/${matchId}/upload-poster`, fd);
      }

      message.success("Match created");
      form.resetFields();
      setPosterFile(null);
      setPosterPreview(null);
      onSuccess?.();
      onClose();
    } catch {
      message.error("Failed to create match");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Create Match"
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
      width="95%"
      style={{ top: 20 }}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="name" label="Match Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item
          name="tournament_id"
          label="Tournament"
          rules={[{ required: true }]}
        >
          <Select disabled>
            {tournaments.map((t) => (
              <Option key={t.tournament_id} value={t.tournament_id}>
                {t.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="start_date" label="Start Date" rules={[{ required: true }]}>
          <DatePicker showTime style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="end_date" label="End Date">
          <DatePicker showTime style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="overs" label="Overs">
          <Input type="number" />
        </Form.Item>

        <Form.Item name="youtube_link" label="YouTube Live Link">
          <Input />
        </Form.Item>

        <Form.Item label="Poster">
          <Upload
            beforeUpload={(file) => {
              setPosterFile(file);
              setPosterPreview(URL.createObjectURL(file));
              return false;
            }}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>Select Poster</Button>
          </Upload>

          {posterPreview && (
            <img
              src={posterPreview}
              alt="poster"
              style={{ width: "100%", marginTop: 10 }}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MatchFormModal;
